import cleanedFilename from '~/util/cleanedFilename';

export default {
  USER: `${cleanedFilename(__filename)}-user`,
  OFFICE: `${cleanedFilename(__filename)}-office`,
  CHECKBOX: `${cleanedFilename(__filename)}-checkbox`,
};
